"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vendorIdSalsaritas = exports.vendorIdPomella = exports.vendorIdModernMarket = exports.vendorIdLemonade = exports.vendorIdGrecianGyro = exports.vendorIdHasScraper = exports.vendorDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function vendorDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        desiredPriceId: (0, unwrap_1.default)(object.desiredPriceId, deserializeString_1.deserializeString),
        invoiceColumns: (0, unwrap_1.default)(object.invoiceColumns, (0, deserializeArray_1.default)(deserializeString_1.deserializeString)),
        invoiceFormulaId: (0, unwrap_1.default)(object.invoiceFormulaId, deserializeString_1.deserializeString),
        name: (0, deserializeString_1.deserializeString)(object.name),
        nameMatches: (0, unwrap_1.default)(object.nameMatches, (0, deserializeArray_1.default)(deserializeString_1.deserializeString)),
        payoutFormulaId: (0, unwrap_1.default)(object.payoutFormulaId, deserializeString_1.deserializeString),
        stripeCustomerId: (0, unwrap_1.default)(object.stripeCustomerId, deserializeString_1.deserializeString),
        stripeSubscriptionId: (0, unwrap_1.default)(object.stripeSubscriptionId, deserializeString_1.deserializeString),
        vendorApplicationId: (0, unwrap_1.default)(object.vendorApplicationId, deserializeString_1.deserializeString),
    };
}
exports.vendorDeserialize = vendorDeserialize;
function vendorIdHasScraper(vendorId, environment) {
    switch (vendorId) {
        case vendorIdLemonade(environment):
            return true;
        case vendorIdGrecianGyro(environment):
        case vendorIdModernMarket(environment):
        case vendorIdPomella(environment):
        case vendorIdSalsaritas(environment):
            return false;
        default:
            return false;
    }
}
exports.vendorIdHasScraper = vendorIdHasScraper;
function vendorIdGrecianGyro(environment) {
    switch (environment) {
        case 'PRODUCTION':
            return 'G0s9Z7jb48gLCnSB2VuK';
        default:
            return 'BZCE6ioHS3t5RrZQtS1P';
    }
}
exports.vendorIdGrecianGyro = vendorIdGrecianGyro;
function vendorIdLemonade(environment) {
    switch (environment) {
        case 'PRODUCTION':
            return 'jbHKlET9pvbjQSc9fG76';
        default:
            return 'V2CmQ6DFBj6ztkaRS9Ie';
    }
}
exports.vendorIdLemonade = vendorIdLemonade;
function vendorIdModernMarket(environment) {
    switch (environment) {
        case 'PRODUCTION':
            return 'yXzJXKjsstiZqVEPnBp0';
        default:
            return '2W15gJGqwUb2MT3njqFC';
    }
}
exports.vendorIdModernMarket = vendorIdModernMarket;
function vendorIdPomella(environment) {
    switch (environment) {
        case 'PRODUCTION':
            return '5SCjraNcasufxp7JwfS3';
        default:
            return 'ZvdWyfKY2PeNZ6ceLx0H';
    }
}
exports.vendorIdPomella = vendorIdPomella;
function vendorIdSalsaritas(environment) {
    switch (environment) {
        case 'PRODUCTION':
            return 'vAsVSQf23XDxnxyTnlxy';
        default:
            return 'fXdA3UH8UsU0LJmqu1LH';
    }
}
exports.vendorIdSalsaritas = vendorIdSalsaritas;
